import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@mui/material';
import { request, methods } from '../../../utils/http-common.js';
import { toastr } from 'react-redux-toastr';

const SaveQueryDialog = (props) => {
  const { open, onClose, query, collectionName, dbQuery, fetchPreviousQueries, moduleID, chartSuggestions = [] } = props;
  const [queryName, setQueryName] = useState('');
  const [error, setError] = useState('');

  const getUserEmail = () => {
    try {
      const userInfo = JSON.parse(localStorage.loggedInUser || '{}');
      return userInfo?.email || '';
    } catch {
      return '';
    }
  };

  const handleSave = async () => {
    const userEmail = getUserEmail();
    if (!userEmail) {
      toastr.error('User email not found. Please log in again.');
      return;
    }

    if (!queryName.trim()) {
      setError('Please enter a name for the query');
      return;
    }

    const [apiError, response] = await request('redirect/ai/log-query/', methods.POST, {
      user_query: query,
      generated_query: dbQuery,
      collection_name: collectionName,
      user_email: userEmail,
      query_name: queryName.trim(),
      module_id: moduleID,
      chart_suggestions: chartSuggestions,
    });

    if (apiError) {
      if (apiError.status === 409) {
        setError('A query with this name already exists. Please choose a different name.');
      } else {
        console.error('Error logging query:', apiError);
        toastr.error(apiError.message || 'Failed to save query');
      }
      return;
    }

    if (response?.data) {
      toastr.success('Query saved successfully');
      fetchPreviousQueries();
      handleClose();
    }
  };

  const handleQueryNameChange = (e) => {
    setQueryName(e.target.value);
    setError('');
  };

  const handleClose = () => {
    setQueryName('');
    setError('');
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Save Your Search</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Query Name"
          type="text"
          fullWidth
          value={queryName}
          onChange={handleQueryNameChange}
          error={!!error}
          helperText={error}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button onClick={handleSave} variant="contained" color="primary">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SaveQueryDialog;
